import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Spinner } from '@instructure/ui-spinner';
import t from 'format-message';
import { scoringMethodShape, stylesShape } from "../../../store/shapes.js";
import { NEW_DECAYING_AVERAGE_FF } from "../../../constants.js";
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
var renderUserFacingMethod = function renderUserFacingMethod(scoringMethod, newDecayingAvgFFEnabled) {
  var legacyDecayingAverage = t('Mastery calculated by Decaying Average. Most recent counts as ' + '{recent_percent, number, percent} of mastery weight, average of all ' + 'other results count as {remain_percent, number, percent} of weight. ' + 'If there is only one result, the single score will be returned.', {
    recent_percent: scoringMethod.algorithm_data.decaying_average_percent,
    remain_percent: 1.0 - scoringMethod.algorithm_data.decaying_average_percent
  });
  if (newDecayingAvgFFEnabled) {
    switch (scoringMethod.algorithm) {
      case 'decaying_average':
        return t('Mastery calculated by Weighted Average. Most recent counts as ' + '{recent_percent, number, percent} of mastery weight, average of all ' + 'other results count as {remain_percent, number, percent} of weight. ' + 'If there is only one result, the single score will be returned.', {
          recent_percent: scoringMethod.algorithm_data.decaying_average_percent,
          remain_percent: 1.0 - scoringMethod.algorithm_data.decaying_average_percent
        });
      case 'standard_decaying_average':
        return t('Mastery calculated by Decaying Average. Between two assessments, ' + 'the most recent assessment gets {recent_percent, number, percent} weight, ' + 'and the first gets {remain_percent, number, percent}. For each additional assessment, ' + 'the sum of the previous score calculations decay by an ' + 'additional {remain_percent, number, percent}. ' + 'If there is only one result, the single score will be returned.', {
          recent_percent: scoringMethod.algorithm_data.standard_decaying_average_percent,
          remain_percent: 1.0 - scoringMethod.algorithm_data.standard_decaying_average_percent
        });
    }
  } else {
    return legacyDecayingAverage;
  }
};
var scoringText = function scoringText(scoringMethod, newDecayingAvgFFEnabled) {
  switch (scoringMethod.algorithm) {
    case 'decaying_average':
      return renderUserFacingMethod(scoringMethod, newDecayingAvgFFEnabled);
    case 'standard_decaying_average':
      return renderUserFacingMethod(scoringMethod, newDecayingAvgFFEnabled);
    case 'n_mastery':
      return t('Mastery calculated by n Number of Times. Must achieve mastery at ' + 'least {n_times, number} times.  Scores above mastery will be ' + 'averaged to calculate final score.', {
        n_times: scoringMethod.algorithm_data.n_mastery_count
      });
    case 'highest':
      return t('Mastery calculated by Highest Score. Mastery score reflects the highest score of a graded assessment.');
    case 'latest':
      return t('Mastery calculated by Most Recent Score. Mastery score reflects the most recent graded assessment.');
    case 'average':
      return t('Mastery reflects Average Score. Calculated by dividing the sum of all item scores by the number of scores.');
    default:
      return '';
  }
};
var masteryText = function masteryText(masteryPercent, artifactTypeName) {
  return t('By aligning to this {artifact_type_name} if the student scores above' + ' {mastery_percent, number, percent} mastery will be achieved.', {
    mastery_percent: masteryPercent,
    artifact_type_name: artifactTypeName
  });
};
var MasteryDescription = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(MasteryDescription, _React$Component);
  var _super = _createSuper(MasteryDescription);
  function MasteryDescription() {
    _classCallCheck(this, MasteryDescription);
    return _super.apply(this, arguments);
  }
  _createClass(MasteryDescription, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        artifactTypeName = _this$props.artifactTypeName,
        displayMasteryPercentText = _this$props.displayMasteryPercentText,
        scoringMethod = _this$props.scoringMethod,
        features = _this$props.features;
      var newDecayingAvgFFEnabled = features.includes(NEW_DECAYING_AVERAGE_FF);
      if (!scoringMethod) {
        return jsx(Spinner, {
          renderTitle: t('Loading')
        });
      }
      return jsx("div", {
        css: this.props.styles.scoreMastery,
        "data-automation": "outcomeView__scoreMethodDescription"
      }, jsx("div", null, jsx(Text, {
        size: "small"
      }, scoringText(scoringMethod, newDecayingAvgFFEnabled))), displayMasteryPercentText && artifactTypeName && jsx("div", {
        css: this.props.styles.scoreMasteryText
      }, jsx(Text, {
        size: "small"
      }, masteryText(scoringMethod.mastery_percent, artifactTypeName))));
    }
  }]);
  MasteryDescription.displayName = "MasteryDescription";
  return MasteryDescription;
}(React.Component), _class2.propTypes = {
  artifactTypeName: PropTypes.string,
  displayMasteryPercentText: PropTypes.bool.isRequired,
  scoringMethod: scoringMethodShape,
  features: PropTypes.array,
  styles: stylesShape
}, _class2.defaultProps = {
  artifactTypeName: null,
  scoringMethod: null,
  features: []
}, _class2)) || _class);
export { MasteryDescription as default };